import { useRef } from 'react';

export const handleOnDelete = (disabled: boolean, onDelete: () => void) => {
  if (!disabled && onDelete) {
    onDelete();
  }
};

export const onTextChangeSubmit = (
  newText: string,
  onTextChange: (newText: string) => void
) => {
  if (onTextChange) {
    onTextChange(newText);
  }
};

export const handleOnTextChange = (
  newText: string,
  setState: (newValue: string) => void,
  setInputError: (newValue: boolean) => void
) => {
  const isInputEmpty = !newText.replace(/\s+/g, '');

  if (typeof newText === 'string') {
    setState(newText);
  }

  setInputError(isInputEmpty);
};

export const handleOnKeyDown = (
  e: React.KeyboardEvent<HTMLInputElement>,
  newText: string,
  onTextChange: (newText: string) => void
) => {
  if (e.key === 'Enter' || e.keyCode === 13) {
    onTextChangeSubmit(newText, onTextChange);
  }
};

export const useFocus = () => {
  const htmlElRef = useRef(null);
  const setFocus = () => {
    if (htmlElRef.current) {
      htmlElRef.current.focus();
    }
  };

  return [htmlElRef, setFocus];
};
